import { useEffect, useState } from 'react';

import TextField from '@mui/material/TextField';

const EmailInput = ({ id, name, type, typeName, order, label, required, options, input: { onChange }, meta }) => {

  const [email, setEmail] = useState("");

  // when component is already mount
  useEffect(() => {
    let defaultValue = "";
    // Compute default value, choose first from options(in normal case there should be single option/value)
    if (options) {
      for (let option of options) {
        if (option.default) {
          defaultValue = option.value;
          // 'cos in text input type only one text is set
          // perhaps in future features will be needed to set joined text options/values into single value 
          break;
        }
      }

      // Set default value
      if (defaultValue) {
        setEmail(defaultValue);

        onChange({
          id,
          typeName,
          order,
          result: defaultValue
        });
      }
    }
  }, []);

  const changeHandler = (event) => {
    setEmail(event?.target?.value);

    if (!event.target.value) {
      return onChange(null);
    }

    return onChange({
      id,
      typeName,
      order,
      result: event.target.value
    });
  }

  return (
    <TextField
      size="small"
      type="email"
      value={email}
      fullWidth
      inputProps={{ pattern: '' }}
      onChange={changeHandler}
    />
  );

  // return (
  //   <div key={id}>
  //     <label>
  //       <input
  //         type="email"
  //         value={email}
  //         onChange={(event) => {
  //           setEmail(event.target.value);

  //           if (!event.target.value) {
  //             return onChange(null);
  //           }

  //           return onChange({
  //             id,
  //             typeName,
  //             order,
  //             result: event.target.value
  //           });

  //         }}
  //       />
  //     </label>
  //   </div>
  // )

}
export default EmailInput;